import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default {
  actions: {
    async createHealthCheckupRequest ({ }, healthCheckupRequest) {
      return (await Vue.http.post(this.state.baseUrl + '/bookingrequest', healthCheckupRequest)).data
    },
    async getHealthCheckupRequests ({ commit }, options) {
      try {
        let response = (await Vue.http.post(this.state.baseUrl + '/bookingrequests/_filter' + '?pageSize=' + (options.pageSize || 3) + '&pageNumber=' + options.pageNumber, options)).data
        if (response && response.data) {
          commit('setState', { stateName: 'checkupRequests', stateValue: response.data })
          return response
        }
      } catch (e) {
        console.log(e)
        return null
      }
    },
    async getLaborders ({ commit }, options) {
      try {
        let response = (await Vue.http.post(this.state.baseUrl + '/laborders/_filter' + '?pageSize=' + (options.pageSize || 3) + '&pageNumber=' + options.pageNumber, options)).data
        if (response && response.data) {
          return response
        }
      } catch (e) {
        console.log(e)
        return null
      }
    },
    async updateHealthCheckupRequestStatus ({ }, options) {
      try {
        let response = (await Vue.http.put(this.state.baseUrl + '/bookingrequest/update/status/' + options.requestId, { status: options.status })).data

        console.log("response : ", response)
        return response
      } catch (e) {
        console.log(e)
        return null
      }
    },

    async getBookingReq ({ }, options) {
      try {
        let response = (await Vue.http.get(this.state.baseUrl + '/bookingrequest/' + options.requestId)).data
        return response
      } catch (e) {
        console.log(e)
        return null
      }
    },


  }
}
